import React from "react";

export default () => {
  return (
    <svg
      width="216px"
      height="188px"
      viewBox="0 0 216 188"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Room</title>
      <g
        id="Wireframe-v4-Layout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="PWA-Desktop-Page4----Room-Dimensions---Human-Comfort"
          transform="translate(-411.000000, -526.000000)"
        >
          <g id="Group-4" transform="translate(203.000000, 379.000000)">
            <g id="Group-6" transform="translate(80.000000, 67.000000)">
              <g id="Group" transform="translate(30.000000, 30.000000)">
                <g id="Group-13" transform="translate(98.000000, 50.000000)">
                  <polygon
                    id="Fill-1"
                    fill="#B3B3B3"
                    points="108 125.000048 54 94 54 155.999952 108 187"
                  ></polygon>
                  <polygon
                    id="Stroke-2"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="108 125.000048 54 94 54 155.999952 108 187"
                  ></polygon>
                  <polygon
                    id="Fill-3"
                    fill="#C5D7E0"
                    points="162 94 108 125.000048 108 187 162 155.999952"
                  ></polygon>
                  <polygon
                    id="Stroke-4"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="162 94 108 125.000048 108 187 162 155.999952"
                  ></polygon>
                  <polygon
                    id="Fill-5"
                    fill="#FFFFFF"
                    points="108 63 54 94 108 125 162 94"
                  ></polygon>
                  <polygon
                    id="Stroke-6"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="108 63 54 94 108 125 162 94"
                  ></polygon>
                  <polygon
                    id="Fill-7"
                    fill="#00AEEF"
                    points="9 185.124336 0 187 6.09497808 180"
                  ></polygon>
                  <path
                    d="M54,156 C54,156 20.1357194,175.754099 6,184"
                    id="Stroke-8"
                    stroke="#00AEEF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="2,3"
                  ></path>
                  <polygon
                    id="Fill-9"
                    fill="#00AEEF"
                    points="209.9051 180 216 187 207 185.124336"
                  ></polygon>
                  <path
                    d="M162,156 C162,156 195.8641,175.754099 210,184"
                    id="Stroke-10"
                    stroke="#00AEEF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="2,3"
                  ></path>
                  <polygon
                    id="Fill-11"
                    fill="#00AEEF"
                    points="105 9 108 0 111 9"
                  ></polygon>
                  <line
                    x1="108"
                    y1="62"
                    x2="108"
                    y2="7"
                    id="Stroke-12"
                    stroke="#00AEEF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="2,3"
                  ></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
